  import styled from "styled-components";
  import { convertFieldName } from "../../utils/commonUtils";
import { MultiSelectDropdownSearch } from "./MultiSelectSearch";
import { useEffect } from "react";

  const Label = styled.label`
    display: flex;
    align-items: center;
    font-size: 0.85rem;
    margin-bottom: 0.1rem;
    color: var(--text-secondary);
  `;

  const Input = styled.input`
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 0.9rem;
    
    &:focus {
      outline: none;
      border-color: var(--primary);
    }
  `;

  const Select = styled.select`
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 0.9rem;
    background: white;
    
    &:focus {
      outline: none;
      border-color: var(--primary);
    }
  `;

  const FormGroup = styled.div`
    margin-bottom: 0.5rem;
  `;

  export const DynamicField = ({ field, value, onChange, customFieldValues }) => {
    const handleChange = (e) => {
      const val = field.type === "int" ? parseInt(e.target.value) || 0 : e.target.value;
      onChange(field.name, val);
    };


    const handleMultiSelect = (fieldName, value) => {
      onChange(fieldName, value);
    }


    if (field.ui_component === "single-select") {
      const isCustom = field.value_list == "custom" ? true : false;
      let options;
      if(!isCustom) {
        const optionsData = field.value_list?.split(",") || [];
        options = optionsData.map((option, index) => ({name: option, id:index}))
      } else {
        options = customFieldValues[field.name];
      }
      return (
        <FormGroup key={field.name}>
          <Label htmlFor={field.name}>{convertFieldName(field.name)} 
                {field.mandatory && <i class="fa-solid fa-asterisk" 
                                        style={{fontSize:'8px', marginLeft:'4px', color:'#d10000'}}
                                        ></i>}
                                        </Label>
          <Select id={field.name} value={value || ""} onChange={handleChange}>
            <option value="">Select {field.name.replaceAll('_',' ')}</option>
            {options?.map((opt, index) => (
              <option key={opt.id || index}>{opt.name}</option>
            ))}
          </Select>   
        </FormGroup>
      );
    }

    if(field.ui_component === "multiple-select") {
      const isCustom = field.value_list == "custom" ? true : false;
      let options;
      if(!isCustom) {
        options = field.value_list?.split(",") || [];
      } else {
        options = customFieldValues[field.name]
      }
      return (
          <FormGroup>
                 <Label htmlFor={field.name}>{convertFieldName(field.name)} 
                {field.mandatory && <i class="fa-solid fa-asterisk" 
                                        style={{fontSize:'8px', marginLeft:'4px', color:'#d10000'}}
                                        ></i>}
                                        </Label>
                <MultiSelectDropdownSearch
                  options={options}
                  selected={value || []}
                  onChange={(newSelectedAssociatedEntities) => {
                    handleMultiSelect(field.name, newSelectedAssociatedEntities)
                  }}
                  placeholder={"Select associated entity"}
                  displayKey="name"
                  valueKey="name"
                />
              </FormGroup>
      )
    }

    return (
      <FormGroup key={field.name}>
        <Label htmlFor={field.name}>{convertFieldName(field.name)} 
              {field.mandatory && <i class="fa-solid fa-asterisk" 
                                      style={{fontSize:'8px', marginLeft:'4px', color:'#d10000'}}
                                      ></i>}
                                      </Label>
        <Input
          id={field.name}
          type={field.type === "int" ? "number" : "text"}
          min="1"
          value={value || ""}
          onChange={handleChange}
          placeholder={field.description || field.name}
        />
      </FormGroup>
    );
  };
